import { Userpilot } from "userpilot"
export { Userpilot as default } from "userpilot"

export function loadUserpilot(key: string) {
  return Userpilot.initialize(key)
}
